import { z } from 'zod';
import { zPrice } from './primitives';

export const registerClosureSchema = z.object({
  cashDiff: z.number(), // Allow for negatives
  cashExpected: z.number(),
  cashActual: z.number(),

  eftposExpected: z.number(),
  eftposActual: z.number(),
  eftposDiff: z.number(), // Allow for negatives

  /** `closedAt` (set locally) allows for offline support in the future. Also allows importing past EOD reports. */
  closedAt: z.number(),
  /** IdForVendor may change if the iOS POS app is uninstalled and reinstalled. `posTerminalUuid` is more likey to be stable reference. */
  posTerminalUuid: z.string().nullable().default(null),
  /**
   * All orders with `createdAfter` within this time period with have `order.registerClosureId`
   * value set when the finaliseTakings() mutation is run.
   */
  ordersCreatedAfter: z.number(),
  ordersCreatedBefore: z.number(),

  /**
   * `creditCardActual` is the sum of all order payments where payment type is 'CREDIT_CARD'.
   * This value should match merchant provider records (eg Stripe).
   **/
  creditCardActual: z.number(),
  /**
   * X/Z report categorySalesRow shows total for the orderItem.
   * This line total includes "order item" level discounts/surcharges.
   * If each orderItem row total is added together, then should match the total of payments received.
   * sum of all order item rows = cash expected + eftpos expected + credit card actual + orderSurchargesTotal - orderDiscountsTotal
   * These discount are "order" level discount/surcharges only, and do not include "order item" discounts/surcharges.
   * These fields are nullable because we have not always calculated these values. To use 0 would be misleading if the values were not calculated.
   **/
  // TODO: These fields are not related to payment reconsiliation / register closures.
  // orderDiscountsTotal: z.number().nullable().default(null),
  // orderSurchargesTotal: z.number().nullable().default(null),

  // TODO: Potentially add in later...
  // cashMovements: zPrice,
  // cashRefunds: zPrice,
  // cashTakings: zPrice,
  // eftposRefunds: zPrice,
  // posUserUuid: z.string().nullable().default(null),

  restaurantId: z.string().optional(),
  _creationTime: z.number().optional(),
  _id: z.string().optional(),
});
export type RegisterClosure = z.output<typeof registerClosureSchema>;

/** Strict schema */
export const registerClosureStrictSchema = registerClosureSchema.extend({
  cashDiff: z.int(),
  cashExpected: zPrice,
  cashActual: zPrice,
  eftposExpected: zPrice,
  eftposActual: zPrice,
  eftposDiff: z.int(),
  creditCardActual: zPrice,
});

/** Convex schema */
export const registerClosureCvxSchema = registerClosureSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  restaurantId: z.string(),
});
export type RegisterClosureCvx = z.output<typeof registerClosureCvxSchema>;
